webpackJsonp([59],{

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_AmountsComponent__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_AmountsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_AmountsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate__);



var loadSubsidiaries = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						response = _context.sent;

						this.subsidiaries = response.data.data || [];
						this.params.idSubsidiary = response.data.data[0] ? response.data.data[0].id : 0;
						if (this.params.idSubsidiary > 0) {
							this.loadData();
						}

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadSubsidiaries() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function created() {
	this.loadSubsidiaries();
}

function columnSortableEvent() {}

function deleteRow() {}

function deleteRows() {}

function exportRows() {}

function goToEdit(_ref) {
	var id = _ref.id;

	this.$router.push({ name: 'companies-edit', params: { id: id } });
}

function loadData() {}

function searchByColumn() {}

function data() {
	return {
		bookings: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'Todas'],
		booking: 0,
		columns: [{ id: 1, name: 'Nombre Completo', code: 'rz_social', isSortable: { down: true, up: false } }, { id: 2, name: 'Nombre Comercial', code: 'company_name', isSortable: { down: true, up: false } }, { id: 3, name: 'Email', code: 'email', isSortable: { down: true, up: false } }, { id: 4, name: 'Reservas', code: 'bookings_number', isSortable: { down: true, up: false } }, { id: 5, name: 'Gasto Total', code: 'total_expenses', isSortable: { down: true, up: false } }, { id: 6, name: 'Cuentas por Cobrar', code: 'accounts', isSortable: { down: true, up: false } }],
		createHref: { name: 'companies-new' },
		params: {
			idSubsidiary: 0,
			page: 1
		},
		rows: [{
			id: 1,
			accounts: 0,
			bookingsNumber: 2,
			companyName: 'Movistar',
			email: 'MovistarSAC@e-gds.com',
			rzSocial: 'Movistar SAC',
			totalExpenses: 1000
		}, {
			id: 2,
			accounts: 200,
			bookingsNumber: 3,
			companyName: 'Zhiontag',
			email: 'Zhiontag@yahoo.es',
			rzSocial: 'Zhiontag AS',
			totalExpenses: 2500
		}],
		subsidiaries: [],
		top: [10, 20, 30, 'Todas'],
		topValue: 0,
		totalPages: 1
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'companies-list',
	components: {
		amountsComponent: __WEBPACK_IMPORTED_MODULE_4__components_shared_AmountsComponent___default.a,
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_5__components_shared_ButtonCreate___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	created: created,
	data: data,
	filters: {
		currency: __WEBPACK_IMPORTED_MODULE_3__shared_filters__["a" /* currency */],
		round: __WEBPACK_IMPORTED_MODULE_3__shared_filters__["c" /* round */]
	},
	methods: {
		columnSortableEvent: columnSortableEvent,
		deleteRow: deleteRow,
		deleteRows: deleteRows,
		exportRows: exportRows,
		goToEdit: goToEdit,
		loadData: loadData,
		loadSubsidiaries: loadSubsidiaries,
		searchByColumn: searchByColumn
	}
});

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".header-booking-data[data-v-6287f6f6]{height:31px;position:absolute;right:20px;text-align:right;top:55px;width:calc(100% - 230px)}.header-booking-data div[data-v-6287f6f6]{padding-bottom:0!important;padding-top:0!important}.header-booking-data p[data-v-6287f6f6]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-6287f6f6]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.header-booking-data .border-select[data-v-6287f6f6]{border-right:1px solid #979797;margin-right:16px;padding-right:16px!important}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/companies/companies-list.vue"],"names":[],"mappings":"AACA,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,0CACI,2BAA+B,AAC/B,uBAA4B,CAC/B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,qDACI,+BAAgC,AAChC,kBAAmB,AACnB,4BAA+B,CAClC","file":"companies-list.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.header-booking-data[data-v-6287f6f6] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 55px;\n  width: calc(100% - 230px);\n}\n.header-booking-data div[data-v-6287f6f6] {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n.header-booking-data p[data-v-6287f6f6] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-6287f6f6] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.header-booking-data .border-select[data-v-6287f6f6] {\n    border-right: 1px solid #979797;\n    margin-right: 16px;\n    padding-right: 16px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("2fa51737", content, true);

/***/ }),

/***/ 1649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.params.idSubsidiary
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "single-line": ""
    },
    model: {
      value: (_vm.params.idSubsidiary),
      callback: function($$v) {
        _vm.params.idSubsidiary = $$v
      },
      expression: "params.idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "mb-3": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select mr3",
    attrs: {
      "hide-details": "",
      "placeholder": "Top",
      "items": _vm.top,
      "single-line": ""
    },
    model: {
      value: (_vm.topValue),
      callback: function($$v) {
        _vm.topValue = $$v
      },
      expression: "topValue"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select mr3",
    attrs: {
      "hide-details": "",
      "placeholder": "Reservas",
      "items": _vm.bookings,
      "single-line": ""
    },
    model: {
      value: (_vm.booking),
      callback: function($$v) {
        _vm.booking = $$v
      },
      expression: "booking"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Nueva Empresa",
      "href": _vm.createHref
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-options": "",
      "include-settings": "",
      "include-delete-single": ""
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-delete-event": _vm.deleteRow,
      "on-delete-selected": _vm.deleteRows,
      "on-export-selected": _vm.exportRows,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.rzSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingsNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.totalExpenses), props.row.currency)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.accounts), props.row.currency)))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1493)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1272),
  /* template */
  __webpack_require__(1649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6287f6f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_mixins__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function subsidiaryId(id) {
	this.loadBookingsTotal(id);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'amounts-component',
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["c" /* round */]
	},
	mixins: __WEBPACK_IMPORTED_MODULE_1__shared_mixins__["a" /* default */],
	props: {
		subsidiaryId: {
			required: true,
			type: [Number, String]
		}
	},
	watch: {
		subsidiaryId: subsidiaryId
	}
});

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, "p[data-v-5c70d746]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}span[data-v-5c70d746]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.border-select[data-v-5c70d746]{border-right:1px solid #979797;padding-right:16px!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/AmountsComponent.vue"],"names":[],"mappings":"AACA,mBACE,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC3B,AACD,sBACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AACD,gCACE,+BAAgC,AAChC,4BAA+B,CAChC","file":"AmountsComponent.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\np[data-v-5c70d746] {\n  color: #2e394b;\n  font-family: \"San Francisco Display\";\n  font-size: 10px;\n  margin: 0px;\n  text-transform: uppercase;\n}\nspan[data-v-5c70d746] {\n  color: #29abe2;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 15px;\n}\n.border-select[data-v-5c70d746] {\n  border-right: 1px solid #979797;\n  padding-right: 16px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("1474b784", content, true);

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c70d746",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', [_vm._v("Ingresos")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.bookingsAmountTotal)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', [_vm._v("Ocupación Actual")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingsTotal))])])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/59.8acb36418c076dd906f6.js